import React, { useEffect, useState } from 'lib/react';
import {
  EVLocationOnOutlinedIcon,
} from 'lib/components';
import PropTypes from 'prop-types';
import { encryptAndEncode } from 'utils/app.utils';
import {
  KEY, INITIALIZATION_VECTOR, LEGACY_PORTAL_LINKS, HOST_URL,
} from 'constants/AppConstants';
import { Link } from 'lib/router';
import { SITEMPAP_ROUTE } from 'constants/RouteConstants';
import { useSelector } from 'lib/redux';
import { featureFlagSelector, isRedirectExceptionOrgSelector } from 'utils/appSelectors.utils';
import * as featureFlags from 'constants/FeatureFlag.constants';

function SitemapLink(props) {
  const {
    reportId,
    orderId,
    signedOrderId,
    label,
    ...rest
  } = props;

  const [encryptedOrderId, setEncryptedOrderId] = useState(null);

  const myevRefreshLegacyRedirectFlag = useSelector(featureFlagSelector(featureFlags.REDIRECT_ACTION_BUTTONS_TO_LEGACY_PORTAL));
  const isRedirectExceptionOrg = useSelector(isRedirectExceptionOrgSelector);

  useEffect(() => {
    let isMounted = true;

    if (orderId) {
      encryptAndEncode(orderId, KEY, INITIALIZATION_VECTOR)
        .then((encryptedID) => isMounted && setEncryptedOrderId(encryptedID));
    }

    return () => { isMounted = false; };
  }, []);

  const linkProps = (() => {
    if (myevRefreshLegacyRedirectFlag) {
      return ({
        href: LEGACY_PORTAL_LINKS.sitemap + encryptedOrderId,
        target: '_blank',
      });
    }

    const signatureQuery = signedOrderId ? `&signature=${encodeURIComponent(signedOrderId)}` : ''; // #genai

    if (isRedirectExceptionOrg) {
      return ({
        to: `${SITEMPAP_ROUTE}?id=${encryptedOrderId}${signatureQuery}`,
        state: { reportId },
      });
    }

    return ({
      href: `${HOST_URL}${SITEMPAP_ROUTE}?id=${encryptedOrderId}${signatureQuery}`,
      target: '_blank',
    });
  })();

  const LinkComponent = isRedirectExceptionOrg ? Link : 'a';

  return (
    <LinkComponent
      id={`sitemapLink-${reportId}`}
      disabled={!encryptedOrderId}
      onClick={(e) => e.stopPropagation()}
      {...linkProps}
      {...rest}
    >
      <EVLocationOnOutlinedIcon style={{ fontSize: 16 }} />
      {label}
    </LinkComponent>
  );
}

SitemapLink.propTypes = {
  reportId: PropTypes.number.isRequired,
  orderId: PropTypes.number.isRequired,
  signedOrderId: PropTypes.string,
  label: PropTypes.element.isRequired,
};

SitemapLink.defaultProps = {
  signedOrderId: null,
};

export default SitemapLink;
